<template>
    <div>
        <router-view/>
    </div>
</template>

<script>
    export default {
        name: "forgot"
    }
</script>

<style scoped>

</style>
